import { Link } from "react-router-dom";
import { useSession, signOut } from "../lib/auth-client";
import { Button } from "./ui/button";

export default function Header() {
  const { data: session } = useSession();

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center justify-between px-4 mx-auto max-w-6xl">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src="/logo.svg" alt="ShopSniffer" className="h-8 w-8" />
          <span className="text-lg font-semibold tracking-tight">ShopSniffer</span>
        </Link>
        <nav className="flex items-center gap-1">
          <Button variant="ghost" size="sm" className="text-primary font-medium" asChild><Link to="/free-export">Free Export</Link></Button>
          <Button variant="ghost" size="sm" asChild><Link to="/stores">Stores</Link></Button>
          <Button variant="ghost" size="sm" asChild><Link to="/use-cases">Use Cases</Link></Button>
          <Button variant="ghost" size="sm" asChild><Link to="/blog">Blog</Link></Button>
          <Button variant="ghost" size="sm" asChild><Link to="/docs">Docs</Link></Button>
          {session ? (
            <>
              <Button variant="ghost" size="sm" asChild><Link to="/dashboard">Dashboard</Link></Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => signOut({ fetchOptions: { onSuccess: () => window.location.assign("/") } })}
              >
                Sign Out
              </Button>
            </>
          ) : (
            <>
              <div className="w-px h-5 bg-border mx-1" />
              <Button size="sm" asChild><Link to="/sign-in">Sign In</Link></Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
